export default __webpack_public_path__ + "static/media/Commercial.77b24e32.svg";